import React from 'react';

class Comp extends React.Component {
    render() {
        return <section className="white">Rankings</section>
    }
}

export default Comp;